export const buttonsVariations = {
  red: {
    primary: {
      hoverColor: '#FFF',
      hoverBackgroundColor: '#e81c24',
    },
  },
};
